import { render, staticRenderFns } from "./simpeg.vue?vue&type=template&id=4435efa2&"
import script from "./simpeg.vue?vue&type=script&lang=js&"
export * from "./simpeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports